@if (items && items.length > 0) {
  <div
    flex
    flexLayout="row"
    flexLayoutAlign="start center"
    flexLayoutGap=".5rem"
    >
    <span>Active Filters</span>
    <mat-icon matTooltip="Active Filters">filter_list</mat-icon>
    <mat-chip-set>
      @for (item of items; track trackByValue($index, item)) {
        <mat-chip
          [removable]="true"
          [disableRipple]="true"
          (removed)="removedHandler(item)"
          >
          <mat-icon [matTooltip]="item.label">filter_alt</mat-icon>
          {{ item.label | replaceString: "-":" " | titlecase }}
          <!-- <div>{{ item.label | replaceString: "-":" " | titlecase }}</div> -->
          <mat-icon matChipRemove matTooltip="Clear this filter">cancel</mat-icon>
        </mat-chip>
      }
    </mat-chip-set>
    <button mat-icon-button matTooltip="Clear all filters" (click)="clearAllHandler()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
}
